import { environment } from '../../../environments/environment';

/**
 * Console wrapper que desabilita logs em produção
 * Use este wrapper ao invés do console.log diretamente
 */
class ConsoleLogger {
    log(...args: any[]): void {
        if (!environment.production) {
            console.log(...args);
        }
    }

    debug(...args: any[]): void {
        if (!environment.production) {
            console.debug(...args);
        }
    }

    info(...args: any[]): void {
        if (!environment.production) {
            console.info(...args);
        }
    }

    warn(...args: any[]): void {
        if (!environment.production) {
            console.warn(...args);
        }
    }

    error(...args: any[]): void {
        // Mantém error sempre ativo
        console.error(...args);
    }

    table(...args: any[]): void {
        if (!environment.production) {
            console.table(...args);
        }
    }

    group(...args: any[]): void {
        if (!environment.production) {
            console.group(...args);
        }
    }

    groupEnd(): void {
        if (!environment.production) {
            console.groupEnd();
        }
    }
}

export const logger = new ConsoleLogger();
